import { FileItem, FileUploader } from 'ng2-file-upload';
import { SavedSnapshot, Snapshot, SnapshotsService } from '@app/services/snapshots.service';

export class SnapshotFileItem extends FileItem {
    public id: string;

    constructor(
        private snapshot: Snapshot,
        private snapshotService: SnapshotsService
    ) {
        super(
            { options: { url: '' } } as FileUploader,
            { name: snapshot.originalName, size: snapshot.size, type: snapshot.mimeType } as File,
            null
        );
        this.id = snapshot.id;
    }

    public override async upload(): Promise<SavedSnapshot> {
        let response;
        try {
            this._onBeforeUpload();
            response = await this.snapshotService.saveSnapshot(this.snapshot);
            this._onSuccess(JSON.stringify(response), 200, {});
            return response;
        } catch (error) {
            this.onError(JSON.stringify(error), 500, {});
        } finally {
            this._onComplete(JSON.stringify(response), 200, {});
        }
    }

    public override remove() {}

    public override onBuildForm() {
        throw new Error('Not implemented');
    }

    public override onProgress() {
        throw new Error('Not implemented');
    }

    public override _onBuildForm() {
        throw new Error('Not implemented');
    }

    public override _onProgress() {
        throw new Error('Not implemented');
    }

    public override _onCancel() {
        throw new Error('Not implemented');
    }

    public override _prepareToUploading() {
        throw new Error('Not implemented');
    }
}
